import * as React from 'react';
import BuyWithERC20, { BuyWithERC20Props } from 'components/BuyWithERC20';
import { BigNumber } from '@ethersproject/bignumber';
import { ERC20Token } from 'components/common';

const BuyWhitelist: React.FC<
  BuyWithERC20Props & {
    price: BigNumber;
    remainingSupply: BigNumber;
    paymentToken: ERC20Token;
  }
> = ({ maxCount, onClick, remainingSupply, paymentToken, networkId, ...rest }) => {
  const max = remainingSupply.lt(maxCount) ? remainingSupply.toNumber() : maxCount;

  return (
    <BuyWithERC20
      maxCountText="You can buy up to"
      submitButtonText="Buy"
      maxCount={max}
      onClick={onClick}
      disabled={remainingSupply.eq(0)}
      paymentToken={paymentToken}
      networkId={networkId}
      tooltipId="mixpassTip"
      {...rest}
    />
  );
};

export default BuyWhitelist;
